<script setup lang="ts">

</script>

<template>
  <div>
    <img width="800" :src="'/loadCatNew.gif'" class="m-auto" loading="eager">
  </div>
</template>

<style scoped>

</style>